var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4017 4.25692C13.26 3.839 12.8633 3.5415 12.3958 3.5415H4.60417C4.13667 3.5415 3.74708 3.839 3.59833 4.25692L2.20292 8.27317C2.15333 8.42192 2.125 8.57775 2.125 8.74067V13.8123C2.125 14.4003 2.59958 14.8748 3.1875 14.8748C3.77542 14.8748 4.25 14.4003 4.25 13.8123V13.4582H12.75V13.8123C12.75 14.3932 13.2246 14.8748 13.8125 14.8748C14.3933 14.8748 14.875 14.4003 14.875 13.8123V8.74067C14.875 8.58484 14.8467 8.42192 14.7971 8.27317L13.4017 4.25692ZM4.60417 11.3332C4.01625 11.3332 3.54167 10.8586 3.54167 10.2707C3.54167 9.68275 4.01625 9.20817 4.60417 9.20817C5.19208 9.20817 5.66667 9.68275 5.66667 10.2707C5.66667 10.8586 5.19208 11.3332 4.60417 11.3332ZM12.3958 11.3332C11.8079 11.3332 11.3333 10.8586 11.3333 10.2707C11.3333 9.68275 11.8079 9.20817 12.3958 9.20817C12.9837 9.20817 13.4583 9.68275 13.4583 10.2707C13.4583 10.8586 12.9837 11.3332 12.3958 11.3332ZM3.54167 7.7915L4.44125 5.08567C4.54042 4.80234 4.80958 4.604 5.11417 4.604H11.8858C12.1904 4.604 12.4596 4.80234 12.5587 5.08567L13.4583 7.7915H3.54167Z",
    fill: "#223E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.050227668bf314743fb2b3c7877f5031.svg";
export { ForwardRef as ReactComponent };